import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _castArray from 'lodash/castArray';
import { EMPTY_STRING, EMPTY_ARRAY } from 'tbase/app.constants';
import Money from 'tbase/utils/money';
import { formatCurrencyWithMoneyFormat, removeMatchedItems } from '../utils';
import { COMM_LIST_TABLE_KEYS } from '../constants/commissionListTable.constants';
import { MANUALLY_UPDATED_API_KEY } from '../constants/desking.constants';
export var calcTotal = function calcTotal(items) {
  return items.reduce(function (sum, elemnt) {
    return Money.add(sum, Number(elemnt.price));
  }, 0);
};
export var filterZeroValues = function filterZeroValues() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return data.filter(function (_ref) {
    var price = _ref.price;
    return Number(price) !== 0;
  }).map(function (_ref2) {
    var price = _ref2.price,
        name = _ref2.name;
    return {
      value: formatCurrencyWithMoneyFormat(price),
      name: name,
      price: price
    };
  });
};
export var getAssigneeInfo = function getAssigneeInfo(assigneeInfo) {
  return {
    displayName: _get(assigneeInfo, 'displayName') || EMPTY_STRING,
    fname: _get(assigneeInfo, 'fname') || EMPTY_STRING,
    lname: _get(assigneeInfo, 'lname') || EMPTY_STRING,
    profilePicture: _get(assigneeInfo, 'profilePicture') || EMPTY_STRING,
    roleID: _get(assigneeInfo, ['userRoleIds', 0], EMPTY_STRING)
  };
};
export var deleteCommissionItem = function deleteCommissionItem() {
  var assignee = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return removeMatchedItems(assignee, 'id', id);
};
export var getUpdatedDataForCommissions = function getUpdatedDataForCommissions(assignee, id, key, value, loggedInUserId) {
  return assignee.map(function (item) {
    var _objectSpread3, _objectSpread5;

    var targetId = item.id,
        spiffAmount = item.spiffAmount,
        amount = item.amount;
    var SPIFF_AMOUNT = Number(spiffAmount);

    if (targetId === id) {
      var _objectSpread2;

      var target = _objectSpread(_objectSpread({}, item), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, key, value), _defineProperty(_objectSpread2, MANUALLY_UPDATED_API_KEY, true), _objectSpread2));

      switch (key) {
        case COMM_LIST_TABLE_KEYS.BASE_COMMISSION_AMOUNT:
          target = _objectSpread(_objectSpread({}, target), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, COMM_LIST_TABLE_KEYS.TOTAL_COMMISSION_AMOUNT, Money.add(Number(value), SPIFF_AMOUNT)), _defineProperty(_objectSpread3, "commissionRuleDisabled", true), _defineProperty(_objectSpread3, "commissionAmountUpdatedBy", loggedInUserId), _objectSpread3));
          break;

        case COMM_LIST_TABLE_KEYS.PERCENTAGE:
          target = _objectSpread(_objectSpread({}, target), {}, {
            percentageModified: true
          });
          break;

        case COMM_LIST_TABLE_KEYS.TOTAL_COMMISSION_AMOUNT:
          target = _objectSpread(_objectSpread({}, target), {}, _defineProperty({}, COMM_LIST_TABLE_KEYS.BASE_COMMISSION_AMOUNT, Money.subtract(Number(value), SPIFF_AMOUNT)));
          break;

        case COMM_LIST_TABLE_KEYS.SPIFF_AMOUNT:
          target = _objectSpread(_objectSpread({}, target), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, COMM_LIST_TABLE_KEYS.TOTAL_COMMISSION_AMOUNT, Money.add(Number(value), Number(amount))), _defineProperty(_objectSpread5, "spiffRuleDisabled", true), _defineProperty(_objectSpread5, "spiffAmountUpdatedBy", loggedInUserId), _objectSpread5));
          break;

        default:
          break;
      }

      return target;
    }

    return item;
  });
};
export var getFilteredAssigneesForCommission = function getFilteredAssigneesForCommission(assignees) {
  if (_isEmpty(assignees)) return EMPTY_ARRAY;
  return assignees.filter(function (assignee) {
    return assignee.userId && assignee.userType;
  });
};
export var isModifiedByUser = function isModifiedByUser(assignees) {
  return _castArray(assignees).find(function (assignee) {
    return assignee.commissionAmountUpdatedBy || assignee.spiffAmountUpdatedBy;
  });
};
export var hasManualOverride = function hasManualOverride(assignees) {
  return _castArray(assignees).find(function (assignee) {
    return assignee.commissionRuleDisabled || assignee.spiffRuleDisabled;
  });
};